import { getConfig } from 'EnvConfig'
import { toPortalHost } from 'utils/portal-config'

import { getEcpDomain } from './ecp-domain'
import { getPublicConfigRequestHeaders } from './request-headers'

const asPages = (body: unknown): unknown[] | undefined => {
  if (Array.isArray(body)) return body

  if (body !== null && typeof body === 'object' && 'data' in body) {
    const data = (body as { data?: unknown }).data

    if (Array.isArray(data)) return data
  }

  return undefined
}

export const requestPublicPortalPages = async (): Promise<
  unknown[] | undefined
> => {
  const raw = getEcpDomain()
  const domain = toPortalHost(raw) ?? raw

  if (!domain) return undefined

  const { CUSTOMER_PORTAL_API_URL } = getConfig()
  const url = new URL(`${CUSTOMER_PORTAL_API_URL}/v2/portal/public/pages`)

  url.searchParams.set('domain', domain)

  const response = await fetch(url.toString(), {
    method: 'GET',
    headers: getPublicConfigRequestHeaders()
  })

  if (!response.ok) {
    throw new Error(`public pages ${response.status}`)
  }

  return asPages(await response.json())
}
